import React, { useMemo } from "react";
import { Field, Formik } from "formik";
import { isEqual } from "lodash";
import { FormattedMessage, useIntl } from "react-intl";
import { useFilterObjectsUIContext } from "../../pages/FilterObjectsUIContext";
import { useDispatch } from "react-redux";
import { useObjectsUIContext } from "../ObjectsUIContext";

export function ReportFilter({
  prepareFilter,
  filterFields,
  filterInitialValues,
  exportfuncName,
  api,
}) {
  // Report UI Context
  const objectsUIContext = useObjectsUIContext();
  const filterUIContext = useFilterObjectsUIContext();
  const dispatch = useDispatch();
  const intl = useIntl();

  const reportUIProps = useMemo(() => {
    return {
      setQueryParams: filterUIContext.setQueryParams,
      queryParams: filterUIContext.queryParams,
      changeFilter: objectsUIContext.changeFilter,
      setChangeFilter: objectsUIContext.setChangeFilter,
    };
  }, [filterUIContext]);

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(reportUIProps.queryParams, values);
    if (!isEqual(newQueryParams, reportUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      reportUIProps.setQueryParams(newQueryParams);
    }
  };

  const createFields = (
    item,
    index,
    values,
    handleSubmit,
    handleBlur,
    handleChange,
    setFieldValue
  ) => {
    if (item.type === "parentComponent") {
      return (
        <div className="col-lg-4 mb-4" key={index}>
          <small className="form-text text-muted">
            <b>{intl.formatMessage({ id: "MODULES.GENERAL.FILTER" })} </b>{" "}
            {intl.formatMessage({ id: item.lable })}
          </small>
          <Field
            name={item.name}
            component={item.component}
            placeholder={intl.formatMessage({ id: item.lable })}
            onBlur={handleBlur}
            value={values[item.name]}
            onChange={(e) => {
              handleChangeLocal({
                val: e.currentTarget.value,
                field: item,
                setFieldValue,
                values,
              });
              handleSubmit();
            }}
          />

        </div>
      );
    } else if (item.type === "select") {
      return (
        <div className="col-lg-4 mb-4" key={index}>
          <small className="form-text text-muted">
            <b>{intl.formatMessage({ id: "MODULES.GENERAL.FILTER" })} </b>{" "}
            {intl.formatMessage({ id: item.lable })}
          </small>
          <select
            className="form-control"
            placeholder={intl.formatMessage({
              id: "MODULES.GENERAL.ADDNEWRECORD",
            })}
            name={item.name}
            onBlur={handleBlur}
            onChange={(e) => {
              setFieldValue(item.name, e.target.value);
              handleSubmit();
            }}
            value={values[item.name]}
          >
            {item.list.map((opt, idx) => (
              <option key={idx} value={opt.value}>
                {intl.formatMessage({ id: opt.lable })}
              </option>
            ))}
          </select>

        </div>
      );
    } else if (item.type === "text") {
      return (
        <div className="col-lg-4 mb-4" key={index}>
          <small className="form-text text-muted">
            <b>{intl.formatMessage({ id: "MODULES.GENERAL.FILTER" })} </b>{" "}
            {intl.formatMessage({ id: item.lable })}
          </small>
          <input
            type="text"
            className="form-control"
            name={item.name}
            placeholder={intl.formatMessage({ id: item.lable })}
            onBlur={handleBlur}
            value={values[item.name]}
            onChange={(e) => {
              setFieldValue(item.name, e.target.value);
              handleSubmit();
            }}
          />


        </div>
      );
    } else if (item.type === "component") {
      return (
        <div className="col-lg-4 mb-4" key={index}>
          <small className="form-text text-muted">
            <b>{intl.formatMessage({ id: "MODULES.GENERAL.FILTER" })} </b>{" "}
            {intl.formatMessage({ id: item.lable })}
          </small>
          <Field
            name={item.name}
            component={item.component}
            placeholder={intl.formatMessage({ id: item.lable })}
            onBlur={handleBlur}
            value={values[item.name]}
            onChange={(e) => {
              console.log("e.target.value");
              console.log(e.target.value);
              setFieldValue(item.name, e.target.value);
              handleSubmit();
            }}
          />

        </div>
      );
    }
    else if (item.type === "multiSelectComponent") {
      return (
        <div className="col-lg-4" key={index}>
          <small className="form-text text-muted">
            <b>{intl.formatMessage({ id: "MODULES.GENERAL.FILTER" })} </b> {item.lable}
          </small>
          <Field
            name={item.name}
            component={item.component}
            placeholder={item.label}
          // value={values[item.name]}
          // onChange={(e) => {
          //   // setFieldValue(item.name, e.target.value);
          //   handleSubmit();
          // }}
          />
        </div>
      );
    }
    else if (item.type === "date") {
      return (
        <div className="col-lg-4 mb-4" key={index}>
          <small className="form-text text-muted">
            <b>{intl.formatMessage({ id: "MODULES.GENERAL.FILTER" })} </b>{" "}
            {intl.formatMessage({ id: item.lable })}
          </small>
          <Field
            name={item.name}
            component={item.component}
            placeholder={intl.formatMessage({ id: item.lable })}
            onBlur={handleBlur}
            value={values[item.name]}
            onChange={(e) => {
              handleSubmit();
            }}
          />

        </div>
      );
    }
    else if (item.type === "treeSelect") {
      return (
        <div className="col-lg-4 mb-4" key={index}>
          <small className="form-text text-muted mb-4">
            <b>{intl.formatMessage({ id: "MODULES.GENERAL.FILTER" })} </b>{" "}
            {intl.formatMessage({ id: item.lable })}
          </small>
          <Field
            name={item.name}
            component={item.component}
            placeholder={intl.formatMessage({ id: item.lable })}
            // onBlur={handleBlur}
            value={values[item.name]}
          // onChange={(e) => {
          //   // setFieldValue(item.name, e.target.value);
          //   handleSubmit();
          // }}
          />

        </div>
      );
    }
    else if (item.type === "searchComponent") {
      return (
        <div className="col-lg-4" key={index}>
          <small className="form-text text-muted mb-4">
            <b>{intl.formatMessage({ id: "MODULES.GENERAL.FILTER" })} </b>{" "}
            {intl.formatMessage({ id: item.lable })}
          </small>
          <Field
            name={item.name}
            component={item.component}
            // placeholder={intl.formatMessage({ id: item.lable })}
            placeholder={intl.formatMessage({ id: "SELECT.ALL" })}
          // onBlur={handleBlur}
          // value={values[item.name]}
          // onChange={(e) => {
          //   setFieldValue(item.name, e.value);
          //   handleSubmit();
          // }}

          // InputProps={{onBlur:handleBlur , onChange:(e) => {
          //   console.log("e.target.value")
          //   console.log(e.target.value)
          //   setFieldValue(item.name, e.target.value);
          //   handleSubmit();
          // }}}

          />

        </div>
      );
    }
  };

  const handleChangeLocal = ({ val, field, setFieldValue, values }) => {
    const temp = { ...filterInitialValues };
    temp[field.name] = val;
    setFieldValue(field.name, +val);
    field.relField.forEach(element => {
      setFieldValue(element, 0);
      temp[element] = 0
    });
    values = {
      ...values,
      ...field.relValues
    }
    values[field.name] = +val
    //applyFilter(temp);

  };

  const handleClick = (values) => {
    reportUIProps.setChangeFilter(true);
  };

  // const handleClickExport = () => {
  //   dispatch(
  //     actions.downloadExcelFile(api, reportUIProps.queryParams, exportfuncName)
  //   );
  // };
  return (
    <>
      <Formik
        initialValues={filterInitialValues}
        onSubmit={(values) => {
          applyFilter(values);
          //reportUIProps.setChangeFilter(!reportUIProps.changeFilter)
        }}
      >
        {({
          values,
          handleSubmit,
          handleBlur,
          handleChange,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit} className="form form-label-right">
            <div className="form-group row">
              {filterFields
                .map((field, index) =>
                  createFields(
                    field,
                    index,
                    values,
                    handleSubmit,
                    handleBlur,
                    handleChange,
                    setFieldValue
                  )
                )}
              <div className="col-lg-3">
                <button
                  type="button"
                  className="btn btn-primary ml-2 mt-12"
                  onClick={() => handleClick(values)}
                >
                  نمایش گزارش
                  {/* {intl.formatMessage({
                    id: "MODULES.GENERAL.BUTTONREPORT",
                  })} */}
                </button>
                {/* <button
                  type="button"
                  className="btn btn-primary ml-2"
                  onClick={() => handleClickExport()}
                >
                  {intl.formatMessage({
                    id: "MODULES.GENERAL.BUTTONREPORT_EXPORT",
                  })}
                </button> */}
              </div>

            </div>
          </form>
        )}
      </Formik>
    </>
  );
}
